import { useLocation, useRouter } from '@tanstack/react-router'
import { useCallback, useEffect, useState } from 'react'

/**
 * @deprecated Use `useDialogVisibility` hook instead
 */
export function useWindowLocationHash(): { hash: string; updateHash: (hash: string) => void } {
  const router = useRouter()
  const location = useLocation()
  const [hash, setHash] = useState(decodeURIComponent(location.hash || ''))

  const updateHash = useCallback(
    (newHash: string) => {
      const formattedHash = newHash.startsWith('#') ? newHash.substring(1) : newHash

      const path = `${location.pathname}${location.searchStr}#${formattedHash}`

      router.history.replace(path)

      setHash(formattedHash)
    },
    [router.history, location.pathname, location.searchStr],
  )

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHash(decodeURIComponent(location.hash || ''))
  }, [location.hash])

  return { hash, updateHash }
}
